import { KpState, UserState } from '@/@types/store/state';
import auth from '@/helpers/auth';

import { User } from '@/models/User';
import { ActionContext } from 'vuex';

export default {
    namespaced: true,
    state: {
        error: null,
        record: null,
    } as UserState,
    mutations: {
        setUser(state: UserState, user: User | null) {
            state.record = User.fromData(user) as User;
        },
        setError(state: UserState, error: string | null) {
            state.error = error;
        },
    },
    actions: {
        /**
         * Executes the FIRST login stage (username / password).
         *
         * A successful password check does not mean the user is logged in: unless he is on
         * the totp exception list, the second factor follows (totpSetup / totpRequired).
         */
        async loginTry(context: ActionContext<UserState, KpState>, data: { username: string; password: string }) {
            context.commit('loading', true, { root: true });
            context.commit('setError', null);
            let user = null;
            let pwChange = false;
            let totpSetup = false;
            let totpRequired = false;
            try {
                const loginResponse = await auth.login(data.username, data.password);
                if (loginResponse.user) {
                    user = User.fromData(loginResponse.user);
                }
                pwChange = loginResponse.password_change === true;
                totpSetup = loginResponse.totp_setup_required === true;
                totpRequired = loginResponse.totp_required === true;
            } catch (err: any) {
                context.commit('setError', String(err.message || err));
            }
            context.commit('loading', false, { root: true });
            return { user, pwChange, totpSetup, totpRequired };
        },

        /**
         * Logs out the user and sets the user state to null.
         */
        async logout(context: ActionContext<UserState, KpState>) {
            context.commit('loading', true, { root: true });
            try {
                await auth.logout();
                context.commit('setUser', null);
                document.location.reload();
            } catch (err: any) {
                context.commit('setError', String(err.message || err));
            }
            context.commit('loading', false, { root: true });
        },
    },
};
